var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFortificationWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6465 3H16.0509C15.8045 3 15.615 3.18947 15.615 3.43594V6.48685L13.2843 6.48611V3.43596C13.2843 3.18949 13.0948 3.00002 12.8483 3.00002H10.2342C9.98768 3.00002 9.79821 3.18949 9.79821 3.43596V6.48687L7.46749 6.48613V3.43598C7.46749 3.18951 7.27802 3.00004 7.03155 3.00004H4.43594C4.18947 3.00004 4 3.18951 4 3.43598V20.5641C4 20.8105 4.18947 21 4.43594 21H18.6658C18.9123 21 19.1018 20.8105 19.1018 20.5641L19.101 3.43598C19.0825 3.18951 18.893 3 18.6465 3ZM13.4737 16.3956C13.4737 16.6421 13.2842 16.8316 13.0378 16.8316H10.0446C9.79817 16.8316 9.6087 16.6421 9.6087 16.3956V12.5684C9.6087 11.5071 10.4613 10.636 11.5411 10.636C12.621 10.636 13.4736 11.5071 13.4736 12.5684L13.4737 16.3956Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortificationWhite);
export default __webpack_public_path__ + "static/media/fortification-white.33d03259d8f2a2caa2750fcbfce0ba76.svg";
export { ForwardRef as ReactComponent };